const COMBINING_MARKS_REGEX = /[\u0300-\u036f]/g
const MULTI_SPACE_REGEX = /\s+/g

const toSafeString = (value: unknown): string => {
  if (typeof value === 'string') {
    return value
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value)
  }

  return ''
}

export const normalizeIdentity = (value: unknown): string =>
  toSafeString(value)
    .normalize('NFD')
    .replace(COMBINING_MARKS_REGEX, '')
    .toLowerCase()
    .trim()
    .replace(MULTI_SPACE_REGEX, ' ')

export const includesNormalized = (source: unknown, query: unknown): boolean => {
  const normalizedQuery = normalizeIdentity(query)
  if (!normalizedQuery) {
    return true
  }

  return normalizeIdentity(source).includes(normalizedQuery)
}

export const isNormalizedMatch = (left: unknown, right: unknown): boolean =>
  normalizeIdentity(left) === normalizeIdentity(right)

